import { LocaleProvider, Tile } from '@op/opds.opux';
import { MessageProvider, MessageObject, useMessage } from '@messageformat/react';
import { useEffect, useState } from 'react';
import { UserForm } from './components/UserForm';
import messages from './messages/msgData.js';
import './index.scss';
import RecommendationComponent from './components/RecommendationComponent';
import { ContentWrapper } from './components/ContentWrapper';
import InvestmentNotification from './components/InvestmentNotification';
import { isBannerLayout, isCorporateUrl } from './util/url';
import { BasicInfo } from './components/BasicInfo';
import instance from './instance';

const msgDataTs: { [key: string]: MessageObject } = messages;

const App = (): JSX.Element => {
  const [profitExpectation, setProfitExpectation] = useState(5);
  const [showRecommendations, setShowRecommendations] = useState(false);
  const locale = (document.documentElement.lang || 'fi').slice(0, 2);
  const [isPerson, setIsPerson] = useState(true);
  const isBanner = isBannerLayout();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const tileHeader = useMessage('basicInfo_title');

  useEffect(() => {
    const isCorporate = async (): Promise<void> => {
      const isCorp = await instance.get('corporate', {}).then((response: any) => {
        return response.data;
      });
      if (isCorp === 'corporate' || isCorp === 'CORPORATE' || isCorporateUrl()) {
        setIsPerson(false);
      }
    };
    isCorporate();
  }, []);

  return (
    <LocaleProvider locale={locale}>
      <MessageProvider messages={msgDataTs[locale]}>
        <ContentWrapper
          condition={isBanner}
          // eslint-disable-next-line react/no-unstable-nested-components
          wrapper={(children: JSX.Element[]) => {
            return <Tile title={tileHeader}>{children}</Tile>;
          }}
        >
          <BasicInfo isBannerLayout={isBanner} />
          <UserForm
            changeProfitExpectation={setProfitExpectation}
            setShowRecommendations={setShowRecommendations}
            isBannerLayout={isBanner}
            isPersonCustomer={isPerson}
          />
          <>
            {showRecommendations && (
              <RecommendationComponent
                profitExpectation={profitExpectation}
                isPersonCustomer={isPerson}
              />
            )}
            {!isBanner || (isBanner && showRecommendations && <InvestmentNotification />)}
          </>
        </ContentWrapper>
      </MessageProvider>
    </LocaleProvider>
  );
};

export default App;
